const toolbox = [
  {
    title: "淨零排放服務",
    category: "課程、顧問、查證",
    src: require('assets/images/home/toolbox/淨零碳排服務.jpg'),
    url: "https://www.itri.org.tw/ListStyle.aspx?DisplayStyle=01&SiteID=1&MmmID=1162132136253006037"
  },
  {
    title: "企業減碳工作坊",
    category: "報名活動",
    src: require('assets/images/home/toolbox/1.jpg'),
    url: "https://ieknet.iek.org.tw/iekevents/Default.aspx"
  },
  {
    title: "碳顧問服務",
    category: "碳顧問服務",
    src: require('assets/images/home/toolbox/2.jpg'),
    url: "https://www.greentrade.org.tw/content/%E7%A2%B3%E9%A1%A7%E5%95%8F-%E6%8F%90%E5%95%8F%E5%96%AE"
  },
  {
    title: "碳足跡資料庫",
    category: "碳足跡資料庫",
    src: require('assets/images/home/toolbox/3.jpg'),
    url: "https://scmp.itri.org.tw/Frontend/WebPage/Database/databaselistB_Industry.aspx"
  },
  {
    title: "企業營運健檢師",
    category: "企業營運健檢師",
    src: require('assets/images/home/toolbox/4.jpg'),
    url: "https://smepass.gov.tw/SMEAExtranet/healthcheckCarbon"
  },
  {
    title: "能源領域氣候變遷調適平台",
    category: "案例說明",
    src: require('assets/images/home/toolbox/氣候變遷平台示意.jpg'),
    url: "https://eicca.itri.org.tw/"
  },
  {
    title: "淨零排放專區",
    category: "案例說明",
    src: require('assets/images/home/toolbox/淨零排放logo.jpg'),
    url: "https://www.itri.org.tw/ListStyle.aspx?DisplayStyle=01&SiteID=1&MmmID=1162127241645721235"
  },
  {
    title: "淨零永續學校",
    category: "案例說明",
    src: require('assets/images/home/toolbox/淨零永續學校.jpg'),
    url: "https://college.itri.org.tw/nzschool/index.html"
  },
  {
    title: "永續管理平台",
    category: "案例說明",
    src: require('assets/images/home/toolbox/永續管理平台.jpg'),
    url: "https://scmp.itri.org.tw/"
  },
]

export default toolbox;